// Project Content Fields Settings Storage
// Controls which narrative content cards are shown on the Project Overview tab.
//
// Fields covered:
//   - Project Objectives
//   - Key Deliverables
//   - Project Notes
//
// Phase 1: localStorage-backed (no backend required)
// Phase 2 [ENGINEERING — Devin]: replace read/write calls with:
//   GET  /api/company/project-content-settings  → load on mount
//   PATCH /api/company/project-content-settings → save on user action
//   Interface stays identical — only the storage layer changes.

export interface ProjectContentSettings {
  /** Show the Project Objectives card on the Overview tab. Default: true */
  showObjectives: boolean;
  /** Show the Key Deliverables card on the Overview tab. Default: true */
  showKeyDeliverables: boolean;
  /** Show the Project Notes card on the Overview tab. Default: true */
  showNotes: boolean;
  /** Last updated ISO timestamp (stamped automatically on save) */
  lastUpdated?: string;
}

const STORAGE_KEY = 'project-content-settings';

export const DEFAULT_PROJECT_CONTENT_SETTINGS: ProjectContentSettings = {
  showObjectives: true,
  showKeyDeliverables: true,
  showNotes: true,
};

export function getProjectContentSettings(): ProjectContentSettings {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULT_PROJECT_CONTENT_SETTINGS };
    const parsed = JSON.parse(raw) as Partial<ProjectContentSettings>;
    return {
      ...DEFAULT_PROJECT_CONTENT_SETTINGS,
      ...parsed,
    };
  } catch {
    return { ...DEFAULT_PROJECT_CONTENT_SETTINGS };
  }
}

export function saveProjectContentSettings(settings: ProjectContentSettings): void {
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ ...settings, lastUpdated: new Date().toISOString() })
    );
  } catch {
    // localStorage unavailable — silently ignore
  }
}
